/* eslint-disable no-undef */
import JsTagVideo from '../ads/jstag/video';
import { logError } from '../log/logger';

export async function loadSSPDataModel(config, position) {
  try {
    const jsvideo = new JsTagVideo(config);
    jsvideo.init(position);

    const result = await jsvideo.call();
    return result;
  } catch (error) {
    logError(error);
    return null;
  }
}

export default {
  loadSSPDataModel,
};
